export const AUTH_TURNSTILE_SCRIPT_ID = 'gameplaysync-auth-turnstile-script';
export const AUTH_TURNSTILE_SCRIPT_URL =
  'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
export const AUTH_TURNSTILE_ALWAYS_PASS_SITE_KEY = '1x00000000000000000000AA';

export const normalizeAuthCaptchaToken = (value) =>
  typeof value === 'string' ? value.trim() : '';

export const createAuthCaptchaOptions = (captchaToken) => {
  const normalizedToken = normalizeAuthCaptchaToken(captchaToken);
  return normalizedToken ? { captchaToken: normalizedToken } : null;
};

export const getAuthTurnstileConfiguration = (environment = import.meta.env) => {
  const enabled =
    String(environment?.VITE_AUTH_TURNSTILE_ENABLED || '')
      .trim()
      .toLowerCase() === 'true';
  const siteKey =
    typeof environment?.VITE_AUTH_TURNSTILE_SITE_KEY === 'string'
      ? environment.VITE_AUTH_TURNSTILE_SITE_KEY.trim()
      : '';

  return {
    enabled,
    siteKey,
    isConfigured: !enabled || Boolean(siteKey),
  };
};
